import { render, staticRenderFns } from "./ListTypeSmsView.vue?vue&type=template&id=e2c5e12e&"
import script from "./ListTypeSmsView.vue?vue&type=script&lang=ts&"
export * from "./ListTypeSmsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports